import { publishReplay, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Brand } from '../../models/brand.model';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class BrandService {

  brands: Brand[];
  brandEditing: Brand;

  private cachedFields: Observable<any>;

  private baseUrl = HttpClientService.BASE_MS_COMMON;

  constructor (
    private h: HttpClientService,
    private messageService: MessageService
  ) { }

  getAll(): Observable<Brand[]> {
    return this.h.get(`${this.baseUrl}/brands`)
      .map(res => {
        return this.brands = res;
      });
  }

  delete(record) {
    return this.h.delete(`${this.baseUrl}/brands/` + record.id)
      .map(res => {
        this.brands.splice(this.brands.indexOf(record), 1);
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Brand deleted'});
      });
  }

  post(newData) {
    return this.h.post(`${this.baseUrl}/brands`, newData)
      .map(res => {
        newData.id = res.id;
        this.brands.push(newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData, id) {
    return this.h.put(`${this.baseUrl}/brands/` + id, newData)
      .map(res => {
        Object.assign(this.brandEditing, newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get(this.baseUrl + '/schema/BrandDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  recover(record){
    return this.h.put(`${this.baseUrl}/brands/recover/` + record.id, {})
      .map(res => {
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Brand recovered'});
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/brand/brand.service.ts